module.exports = __webpack_public_path__ + "img/jarom-vogel-untitled.a60dc92.jpg";